import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'burialsSearchText'
})
export class BurialsSearchTextPipe implements PipeTransform {

  transform(burials: any[], searchText: string): any[] {
    if (!searchText || searchText.length === 0) { 
      return burials; 
    }

    const searchLower = searchText.toLowerCase().trim();

    return burials.filter(burial => {
      if (!burial) return false;
      
      // Suche in allen Eigenschaften des Burial-Objekts
      return this.searchInObject(burial, searchLower);
    });
  }

  private searchInObject(obj: any, searchText: string): boolean {
    if (!obj) return false;
    
    // Wenn es ein String ist, direkt suchen
    if (typeof obj === 'string') {
      return obj.toLowerCase().includes(searchText);
    }
    
    // Wenn es ein Array ist, in jedem Element suchen
    if (Array.isArray(obj)) {
      return obj.some(item => this.searchInObject(item, searchText));
    }
    
    // Wenn es ein Objekt ist, in allen Eigenschaften suchen
    if (typeof obj === 'object') {
      // Spezielle Behandlung für burialData, da es ein wichtiges Feld ist
      if (obj.burialData) {
        if (this.searchInObject(obj.burialData, searchText)) {
          return true;
        }
      }
      
      // Spezielle Behandlung für searchableString, falls vorhanden
      if (obj.searchableString && typeof obj.searchableString === 'string') {
        if (obj.searchableString.toLowerCase().includes(searchText)) {
          return true;
        }
      }
      
      // In allen anderen Eigenschaften suchen
      for (const key in obj) {
        // Überspringe Funktionen und interne Eigenschaften
        if (typeof obj[key] === 'function' || key.startsWith('_')) {
          continue;
        }
        
        // Suche in der Eigenschaft
        if (this.searchInObject(obj[key], searchText)) {
          return true;
        }
      }
    }
    
    return false;
  }
}

